import { CATEGORIES } from "../../lib/format";

export const CategoryBadge = ({ category, className = "" }) => {
  const c = CATEGORIES[category] || CATEGORIES.genel;
  return <span className={`inline-block px-2.5 py-1 rounded-full text-[11px] font-bold tracking-wide ${c.cls} ${className}`}>{c.label}</span>;
};
